import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	colourByLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by.colour-by-label',
		defaultMessage: 'Color by',
		description: 'The label to display for the colour by dropdown',
	},
});
